import { Col, Radio } from 'antd';
import { Outlet, useMatch } from 'react-router-dom';

import useAPIQuery from '../../api/useAPIQuery';
import Filter from '../../components/Filter';
import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';

const StaffNavigator = () => {
  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/settings/cs-staff/:activeTabKey/*');
  const config = useAPIQuery('/configs/tenant-configurations/');

  return (
    <>
      <Filter>
        <Col flex={1}>
          <Radio.Group
            options={[
              ...(config.data?.t001_enableCentralizedAuthIntegration
                ? []
                : [
                    {
                      value: 'users',
                      label: 'Gerenciar Usuários',
                    },
                  ]),
              {
                value: 'staff-users',
                label: 'Usuários CS',
              },
              {
                value: 'import-files',
                label: 'Importar arquivos',
              },
              {
                value: 'tenant-config',
                label: 'Configurações do Tenant',
              },
              {
                value: 'mindmatch-integration',
                label: 'Integração Mindmatch',
              },
              {
                value: 'external-integrations',
                label: 'Integrações Externas',
              },
            ]}
            onChange={({ target: { value } }) => {
              switch (value) {
                case 'users':
                  navigate(
                    { pathname: '/:tenant/settings/cs-staff/users/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'staff-users':
                  navigate(
                    { pathname: '/:tenant/settings/cs-staff/staff-users/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'import-files':
                  navigate(
                    { pathname: '/:tenant/settings/cs-staff/import-files/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'tenant-config':
                  navigate(
                    { pathname: '/:tenant/settings/cs-staff/tenant-config/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'mindmatch-integration':
                  navigate(
                    {
                      pathname: '/:tenant/settings/cs-staff/mindmatch-integration/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'external-integrations':
                  navigate(
                    {
                      pathname: '/:tenant/settings/cs-staff/external-integrations/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
              }
            }}
            value={match?.params?.activeTabKey || 'staff-users'}
            optionType="button"
          />
        </Col>
      </Filter>
      <Outlet />
    </>
  );
};

export default StaffNavigator;
